<template>
  <div class="card-function-bar">
    <div v-if="data.photo && !isMiniBankInsurance" class="card-wrap">
      <div class="card-item card-user">
        <name-card :name-card-infor="data" />
      </div>
      <div class="card-item card-telephone">
        <a
          :href="`tel:${data.telephone}`"
          data-stat-id="phone"
          :data-stat-ep="
            JSON.stringify({
              productId: data.insuranceTypeId,
            })
          "
        >{{ data.telephone }}</a>
      </div>
    </div>
    <!-- 底部栏只在小程序 && 非银保c && 无nobar 显示 -->
    <footer v-if="isBarRealShow" class="function-bar">
      <div class="function-inner">
        <div v-if="isMiniBankInsurance && isPolicyCheck" class="function-bd">
          <a class="btn interpretation" :href="policyListUrl">保存</a>
          <a
            class="btn share"
            data-stat-id="share_bottom"
            @click="handleShare"
          >分享</a>
        </div>
        <div v-else class="function-bd">
          <a
            class="btn generate"
            href="javascript:;"
            data-stat-id="sc_pdf"
            @click="handleClick('generate')"
          >导出文档</a>
          <a
            v-if="isMiniBankInsurance"
            class="btn interpretation"
            href="javascript:;"
            @click="handleClick('interpretation')"
          >讲解方案</a>
          <a
            class="btn share"
            data-stat-id="share_bottom"
            @click="handleShare"
          >转发计划书</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import QS from 'qs'
import { reg } from 'api/config'
import { isMiniBankInsurance } from 'base/config'
import { getUrlParam, getUrlByAddingParam } from 'common/js/common'
import NameCard from './nameCard'
import Vue from 'vue'
import { MessageBox } from 'bxs-ui-vue'
Vue.use(MessageBox)

export default {
  components: {
    NameCard,
    [MessageBox.name]: MessageBox
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      isMiniBankInsurance,
      telephone: '',
      isBarShow: true,
      isShowSameScreenGuide: false,
      wxBtnConfig: {}
    }
  },
  computed: {
    isBarRealShow () {
      const { isBarShow } = this
      return isBarShow
    }
  },
  created () {
    const isBarShow = getUrlParam('nobar')
    if (isBarShow == 1 || isBarShow) {
      this.isBarShow = false
    }
    this.isPolicyCheck = getUrlParam('pbType')
    const uuid = (this.uuid = getUrlParam('uuid'))
    const theme = getUrlParam('theme')
    const sourceFrom = JSON.stringify({ uuid, theme })
    this.data.nameCard = getUrlByAddingParam({ sourceFrom }, this.data.nameCard)
    this.policyListUrl = `https://policy-inspection.winbaoxian.${
      reg ? 'com' : 'cn'
    }/annualSurvey/family-policy.html?nw=1&cid=${getUrlParam('familyhead')}`
  },
  methods: {
    showSameScreenGuide (bool) {
      this.isShowSameScreenGuide = bool
    },
    handleClick (type) {
      this.$emit(type)
    },
    handleShare () {
      if (isMiniBankInsurance && window.WeCom && WeCom.showTopArrow) {
        WeCom.showTopArrow()
        return
      }

      const toUrl = `${location.origin + location.pathname}?${QS.stringify({
        uuid: this.uuid,
        theme: this.theme,
        cardUuid: this.data.uuid,
        inGroup: true,
        isShareFormWeApp: 1,
        shareFrom: 'mpH5ShareBtn'
      })}`
      wx.miniProgram.navigateTo({
        url: `/pages/subscribe/index?toUrl=${encodeURIComponent(toUrl)}`
      })
    }
  }
}
</script>

<style lang="postcss" scoped>
@import 'variable';

.card-function-bar {
  position: relative;
  width: 94.667%;
  margin: 0 auto 0.2rem;
  font-size: 0.26rem;
  border-radius: 6px;
  background-color: #fff;
  text-align: center;
  .after-bd-r:after {
    height: 40%;
    bottom: 30%;
    background-color: rgba(51, 51, 51, 0.4);
  }
  .card-wrap {
    width: 100%;
    display: flex;
    border-radius: 6px;
    overflow: hidden;
  }
}

.card-item {
  float: left;
  position: relative;
  background-color: #fff;
  > a {
    display: block;
    height: 1.2rem;
    line-height: 1.2rem;
    color: var(--thre-color);
  }
}

.card-user {
  width: 38.7%;
  padding-left: 0.3rem;
}

.card-telephone {
  width: 33%;
}

.card-edit,
.card-view {
  width: 28.3%;
}

.card-telephone,
.card-view {
  .iconfont {
    margin-right: 0.12rem;
    font-size: 0.36rem;
    line-height: 1;
    vertical-align: middle;
  }
  span {
    font-size: 0.28rem;
    vertical-align: middle;
    line-height: 1;
  }
}

.card-edit {
  span {
    display: inline-block;
    padding: 0.18rem 0.24rem;
    font-size: 0.26rem;
    line-height: 1.3;
    border-radius: 6px;
  }
}

.line {
  &:before,
  &:after {
    @apply --bd-w;
    background-color: var(--efive-color);
    height: 58%;
    top: 21%;
  }
  &:before {
    left: 6%;
  }
  &:after {
    right: 6%;
  }
}

.function-bar {
  z-index: 100;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 0.14rem 0;
  box-sizing: content-box;
  font-size: 0.28rem;
  text-align: center;
  .function-inner {
    display: flex;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .btn {
      margin-left: 0.2rem;
      white-space: nowrap;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .function-hd {
    flex: 1;
    text-align: left;
    .iconfont {
      padding-left: 0.34rem;
    }
    p {
      font-size: 0.24rem;
    }
    .name-card {
      line-height: 36px;
    }
  }
  .function-bd {
    display: flex;
    flex: 2;
  }
  .record {
    display: inline-block;
    color: #333;
  }
  .btn {
    display: block;
    flex: 1;
    line-height: 34px;
    border-radius: 6px;
    border: 1px solid #ccc;
    &:last-child {
      flex: 2;
    }
  }
}

@media screen and (device-width <= 320px) {
  .card-function-bar {
    .card-telephone,
    .card-view {
      span {
        font-size: 0.24rem;
      }
    }
  }
}
</style>

<style lang="postcss">
.function-hd {
  .name-card {
    .head {
      width: 0.7rem;
    }
    .info {
      padding-left: 0.84rem;
    }
  }
  .member {
    .name {
      line-height: 1;
    }
  }
}
</style>
